

import Swiper from 'vux/src/components/swiper/swiper.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import Panel from 'vux/src/components/panel/index.vue'




export default {
name: 'Main',
components:{
Swiper,
Marquee,
MarqueeItem,
Panel
},
computed:{
bannerData() {
return this.$store.getters.bannerData;
},
newsList(){
return this.$store.getters.newsList;
},
moreList(){
return this.$store.getters.moreList;
}
},
data(){
return{
slideIndex: 0
}
},
methods: {
newFontdetail (i) {
window.open(this.$store.getters.bannerData[i].url);

}
}


}



// WEBPACK FOOTER //
// ./src/components/Main.vue